export function useAnchorScroll() {
    function getOffsetTop(id: string) {
        const element = document.getElementById(id);

        if (element) {
            return element.getBoundingClientRect().y - 50 + window.scrollY;
        }

        return null;
    }

    function scrollToAnchor(id: string) {
        const offset = getOffsetTop(id);
        if (offset) {
            window.scrollTo({ top: offset, behavior: 'smooth' });
            return true;
        }

        return false;
    }

    return { getOffsetTop, scrollToAnchor };
}
